module.exports = __webpack_public_path__ + "assets/img/soldiers_1.6ba3263d.png";